// extracted by mini-css-extract-plugin
export default {"layout":"_03b811341c _2a0d33a13e _9d900c98f8","h_slide":"_3e79e85137","category":"_1d5db4cf73 _33a7832869 _66eaaac8cd"};